import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, importProvidersFrom, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { SharedStore } from '@shared/store/shared.signal-store';
import { BaseAuthService } from '@stillmandigital/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import {
  bBookLpApiConfigurationProvider,
  coreApiConfigurationProvider,
  fineryApiConfigurationProvider,
  fireblocksApiConfigurationProvider,
  hiddenRoadApiConfigurationProvider,
  houseLpApiConfigurationProvider,
  mainBookLpApiConfigurationProvider,
  principalRiskLpApiConfigurationProvider,
  syntheticLpApiConfigurationProvider,
  zerohashApiConfigurationProvider,
} from './auth/services/api-config.factory';
import { AuthInterceptor } from './auth/services/auth.interceptor';
import { AuthService } from './auth/services/auth.service';
import { LoadScriptHandler } from './error-handling/load-script-handler';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [AuthModule, BrowserModule, AppRoutingModule, BrowserAnimationsModule],
  providers: [
    coreApiConfigurationProvider,
    houseLpApiConfigurationProvider,
    zerohashApiConfigurationProvider,
    fineryApiConfigurationProvider,
    fireblocksApiConfigurationProvider,
    principalRiskLpApiConfigurationProvider,
    bBookLpApiConfigurationProvider,
    hiddenRoadApiConfigurationProvider,
    mainBookLpApiConfigurationProvider,
    syntheticLpApiConfigurationProvider,
    {
      provide: BaseAuthService,
      useExisting: AuthService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    importProvidersFrom(MatNativeDateModule),
    {
      provide: ErrorHandler,
      useClass: LoadScriptHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [SharedStore],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
